import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  CircularProgress,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { usePickupRequests } from "../hooks/usePickupRequests";

function CreatePickupRequest() {
  const navigate = useNavigate();
  const {
    availableCouriers,
    loading,
    error,
    setError,
    success,
    setSuccess,
    createPickupRequest,
  } = usePickupRequests();

  const [creatingFor, setCreatingFor] = useState(null);

  const handleCreate = async (courier) => {
    setCreatingFor(courier);
    try {
      await createPickupRequest(courier);
    } catch (_) {
      // error ya seteado en el hook
    } finally {
      setCreatingFor(null);
    }
  };

  const handleGoToAssign = () => {
    navigate("/home/pickup-requests/assign");
  };

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item xs>
          <Typography variant="h5" fontWeight="bold">
            Crear solicitud de retiro
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Selecciona el courier para el cual quieres crear una solicitud de retiro para hoy.
          </Typography>
        </Grid>
        <Grid item>
          <Button variant="outlined" onClick={handleGoToAssign}>
            Ver solicitudes y asignar pedidos
          </Button>
        </Grid>
      </Grid>

      {error && (
        <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {loading && !creatingFor && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {!loading && availableCouriers.length === 0 && (
        <Alert severity="info">
          No tienes couriers con solicitudes de retiro habilitadas. Contacta a tu operador.
        </Alert>
      )}

      <Grid container spacing={3}>
        {availableCouriers.map(({ courier }) => (
          <Grid item xs={12} sm={6} md={4} key={courier}>
            <Card variant="outlined">
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
                  <LocalShippingIcon color="primary" />
                  <Typography variant="h6" textTransform="capitalize">
                    {courier}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  Crea una solicitud de retiro para que {courier.toUpperCase()} retire tus envíos hoy o
                  el próximo día hábil según el horario de corte.
                </Typography>
              </CardContent>
              <CardActions sx={{ px: 2, pb: 2 }}>
                <Button
                  variant="contained"
                  fullWidth
                  disabled={creatingFor === courier}
                  onClick={() => handleCreate(courier)}
                  startIcon={
                    creatingFor === courier ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : null
                  }
                >
                  {creatingFor === courier ? "Creando..." : "Crear solicitud"}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Snackbar
        open={Boolean(success)}
        autoHideDuration={5000}
        onClose={() => setSuccess(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" onClose={() => setSuccess(null)}>
          {success}{" "}
          <Button size="small" color="inherit" onClick={handleGoToAssign}>
            Ir a asignar pedidos →
          </Button>
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default CreatePickupRequest;
